import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import c from 'classnames';
import { showNavMenu, hideNavMenu } from '../../../actions/UI';

import {
  Container,
  Logo,
} from '../../../components';

import {
  NavigationCampaignMenu,
} from '../..';

import AnimationWrapper from '../AnimationWrapper';
import './style.scss';

class NavigationCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      reachedTop: true,
      scrolledPastNavHeight: true,
    };
  }

  onUpdateAnimationWrapper = (isVisible, hasReachedTop, scrolledPastNavHeight) => {
    const shouldUpdate = (
      this.state.visible !== isVisible
      || this.state.reachedTop !== hasReachedTop
      || this.state.scrolledPastNavHeight !== scrolledPastNavHeight
    );

    if (shouldUpdate) {
      this.setState({
        scrolledPastNavHeight,
        visible: isVisible,
        reachedTop: hasReachedTop,
      });
    }
  };

  onHamburgerClick = () => {
    if (this.props.showNavMenu) {
      this.props.dispatch(hideNavMenu());
    } else {
      this.props.dispatch(showNavMenu());
    }
  };

  onClickMenuItem = (e) => {
    this.props.dispatch(hideNavMenu());
  };

  toggleNavigationItem = (entityId) => {
    const { menuItemsToggled } = this.state;

    this.setState((prevState) => ({
      menuItemsToggled: {
        ...menuItemsToggled,
        [entityId]: !prevState.menuItemsToggled[entityId],
      },
    }));
  };

  toggleSearch = () => {
    this.setState((prevState) => ({
      searchVisible: !prevState.searchVisible,
    }));
  };

  render() {
    const { reachedTop, visible, scrolledPastNavHeight } = this.state;
    const { campaignEntity } = this.props;
    const campaignMenuId = campaignEntity.getIn([0, 'entity', 'field_menu_id', 0, 'value']);

    const classes = c('NavigationCampaign', {
      's-reached-top': reachedTop,
      's-visible': visible,
      's-scrolled-past-nav-height': scrolledPastNavHeight,
    });

    return (
      <AnimationWrapper onUpdate={this.onUpdateAnimationWrapper} scrolledPastNavHeight={scrolledPastNavHeight}>
        <Container className="NavigationCampaign-container">
          <div className={classes} ref={(node) => this.menuNode = node}>
            <Logo isCampaign />
            {campaignMenuId && (
              <NavigationCampaignMenu campaignMenuId={campaignMenuId} />
            )}
          </div>
        </Container>
      </AnimationWrapper>
    );
  }
}

function mapStateToProps(state, ownProps) {

  return {
    showNavMenu: state.getIn(['uiInternal', 'showNavMenu']),
  };
}

export default withRouter(connect(mapStateToProps)(NavigationCampaign));
